export default __webpack_public_path__ + "static/media/project.0d0d8ff6.png";